import {
  Divider,
  TextField,
  Grid,
  Typography,
  Button,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import moment, { Moment } from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import ChevronLeftOutlinedIcon from '@mui/icons-material/ChevronLeftOutlined';
import CropSquareIcon from '@mui/icons-material/CropSquare';

interface Props {
  onClose: any,
  open: boolean,
  getData: any,
  getEmployeeName: string
}
const LeaveHistoryModal = (props: Props) => {
  const textStyle = {
    fontSize: '12px',
    color: '#5B5B5B',
    fontWeight: 400,
    marginLeft: '5px'
  };

  const textWrap = {
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center',
  }

  const subtextStyle = {
    fontSize: '10px',
    color: '#5B5B5B',
    fontWeight: 400,
    marginLeft: '15px'
  }

  const iconWrap = {
    display: 'flex',
    alignItems: 'center'
  }

  const iconStyle = {
    fontSize: 10,
    color: '#5569FF',
    transform: 'rotate(45deg)'
  }

  const TextFieldStyle = {
    paddingTop: 2,
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '12px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '12px',
    height: '2.25rem'
  };

  const titleStyles = {
    fontWeight: '700',
    fontSize: '15px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"'
  };

  const monthStyles = {
    fontWeight: '500',
    fontSize: '12px',
    fontFamily:
      'Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '6px',
    paddingBottom: '6px',
    cursor: 'pointer'
  }

  const monthWapper = {
    paddingTop: '8px',
    paddingBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around'
  }

  const [activeMonth, setActiveMonth] = useState('');
  const [startDate, setStartDate] = useState<any>();
  const [year, setYear] = useState<any>();
  const [calendarData, setCalenderData] = useState([]);
  const [markDays, setMarkDays] = useState([]);
  const [test, setTest] = useState([]);

  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  useEffect(() => {
    const current = new Date();
    setStartDate(current);
    setActiveMonth(months[current.getMonth()]);

    const year = current.getFullYear();
    setYear(year);
  }, []);

  const handleClose = () => {
    props.onClose();
    const current = new Date();
    setActiveMonth(months[current.getMonth()]);
  };

  const handleActive = (month) => {
    setActiveMonth(month);

    const monthIndex = months.indexOf(month) + 1;
    const date = monthIndex.toString().padStart(2, "0") + '-01-' + year;
    setStartDate(new Date(date));
  };

  const handleChangeYear = (date) => {
    const dateWithYear = new Date(date);
    const year = dateWithYear.getFullYear();
    setStartDate(new Date(date));
    setYear(year);
  }

  const Month = ({month}) => {
    return(
      <div 
        className={activeMonth === month ? 'active-month': ''} 
        style={monthStyles} 
        onClick={(e) => handleActive(month)}
      >
        {month}
      </div>
    );
  }

  useEffect(() => {
    if (startDate instanceof Date) {
      setStartDate(startDate);
    }
  }, [startDate]);

  useEffect(() => {
    //set monthly leave
    let selectedDay;
    const selectedMonthlyData = props?.getData.filter((item) => {
      if (year.toString() === item.relevantYear) {
        if (activeMonth === item.relevantMonth) {
          selectedDay = item?.fromDate;
          return item;
        }
      }
    });
    setCalenderData(selectedMonthlyData);

    //remove weekend days
    const d = new Date(selectedDay);
    const getTot = daysInMonth(d.getMonth(), d.getFullYear());
    let sat = []; //Declaring array for inserting Saturdays
    let sun = []; //Declaring array for inserting Sundays

    for (var i = 1; i <= getTot; i++) {
      //looping through days in month
      var newDate = new Date(d.getFullYear(), d.getMonth(), i);
      if (newDate.getDay() == 0) {
        //if Sunday
        sun.push(i);
      }
      if (newDate.getDay() == 6) {
        //if Saturday
        sat.push(i);
      }
    }

    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

    //set mark days
    let leaveRange = [];
    const leaveDays = props?.getData.map((item) => {
      const start = new Date(item.fromDate);
      const end = new Date(item.toDate);
      let loop = new Date(start);
      while (loop <= end) {
        leaveRange.push(moment(loop).format('MM-DD-YYYY'));
        const newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }

      return leaveRange;
    });

    //remove select weekend days
    const days = leaveDays[0];
    let selectWeekendDays = [];

    const filterWeekendDays = days?.map((item) => {
      return { value: item, day: new Date(item).getDate() };
    });

    filterWeekendDays?.map((d) => {
      sat?.map((y) => {
        if (d?.day === y) {
          selectWeekendDays.push(d?.value);
        }
      });
      sun?.map((z) => {
        if (d?.day === z) {
          selectWeekendDays.push(d?.value);
        }
      });
    });

    const leaveWeekDays = leaveDays[0]?.filter(function (obj) {
      return selectWeekendDays.indexOf(obj) == -1;
    });

    setMarkDays(leaveWeekDays);
  }, [activeMonth, props.getData, year]);


  return (
    <Dialog
      open={props.open}
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={handleClose}
      sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}
    >
      <div style={{width: '650px'}}>
        <>
          <Grid
            item
            xs={12}
            style={{ marginTop: '1rem' }}
            sx={{ mt: 5, pb: 2, pl: 2 }}
          >
            <Typography style={titleStyles}>Leave History - {props.getEmployeeName}</Typography>
          </Grid>
          <Divider/>
            <Grid style={monthWapper}>
              {months.map((element) => {
                return(<Month month={element}/>)
              })}
            </Grid>
          <Divider/>
          <Grid container>
            <Grid item xs={6} 
            sx={{ borderRight: '1px solid rgba(0, 0, 0, 0.12)', maxHeight: '19rem', overflow: 'scroll'}}
            className='hide-scroll-bar'>
              {calendarData && calendarData?.length > 0 && calendarData.map((item) => (
                <>
              <Grid sx={{padding: '1rem'}}>
                <Grid style={textWrap}>
                  <Grid style={iconWrap}>
                    <CropSquareIcon sx={iconStyle}/>
                    <Typography style={textStyle} fontWeight="light" variant="h5">
                      {item?.fromDate === item?.toDate ? moment(item?.fromDate).format("D MMM Y") 
                      : moment(item?.fromDate).format("D MMM Y") + ' - ' + moment(item?.toDate).format("D MMM Y")}
                    </Typography>
                  </Grid>
                  <Typography style={textStyle} fontWeight="light" variant="h5">
                    {item?.typeName}
                  </Typography>
                </Grid>
                <Typography style={subtextStyle} fontWeight="light" variant="h5">
                  { moment(item?.fromDate).format("MM-DD-YYYY") === moment(item?.toDate).format("MM-DD-YYYY") 
                  ? item?.dateType ? 'Full Day' 
                  : item?.halfDayType ? 'Morning' : item?.halfDayType === false ? 'Evening' : 'Half Day' 
                  : item?.daysCount + ' Days'}
                </Typography>
              </Grid>
              <Divider/>
              </>
              ))}
              {calendarData.length === 0 && (
                <>
                <Grid sx={{padding: '1rem'}}>
                <Typography style={textStyle} fontWeight="light" variant="h5">
                 The employee did not take any leaves in this month
                </Typography>
                </Grid>
                </>
              )}
            </Grid>
            <Grid item xs={6}>
              <Calendar 
                next2Label={<ChevronRightOutlinedIcon style={{fontSize: '18px'}}/>}
                prev2Label={<ChevronLeftOutlinedIcon style={{fontSize: '18px'}}/>}
                tileClassName={({ date, view }) => {
                  if(markDays?.find(x=>x===moment(date).format("MM-DD-YYYY"))){
                   return  'highlight'
                  }
                }}
                onActiveStartDateChange={({ activeStartDate }) => handleChangeYear(activeStartDate)}
                /* value={moment(startDate)} */
                activeStartDate={startDate}
              />
            </Grid>
          </Grid>
          <Divider/>
          <Grid 
            item
            sx={{
              mb: 2,
              mt: 2,
              pr: 2,
              display: 'flex',
              justifyContent: 'flex-end'
            }}>
            <Button
              sx={{
                width: '100px',
                ml: 2,
                fontSize: '13px',
                fontWeight: 'normal',
                background: '#F5F7FF',
                color: '#5569ff'
              }}
              variant="contained"
              onClick={(e) => {
                handleClose();
              }}
            >
              Close
            </Button>
          </Grid>
        </>
      </div>
    </Dialog>
  );
}

export default LeaveHistoryModal;
